import Vuex from 'vuex';
import {getAxios, getOrders, getRequestsByOrder, getUsers} from "@api";
import {notifyError} from "@components/Notification";
import get from "lodash/get";
import axios from "axios";
import uniq from "lodash/uniq";
import {currentUser, getIDFromString} from "@utilities/functions";
import emailBody from "@clientSpecific/email/template/EmailBody";
import escapeTwig from "@clientSpecific/email/template/escapeTwig";
import {settings} from "@clientSpecific/utilities/settings";
import Vue from 'vue';
import moment from "moment/moment";

const orderQueryString = '_groups[]=order_list_read&_groups[]=order_read_extended_contacts&_groups[]=contact_read&_groups[]=contact_read_relations&_groups[]=provider_read_list&_groups[]=agency_read_list';

Vue.use(Vuex);
const isDirection = function (email, state, direction) {
    for (let i = 0, len = state.types.length; i < len; i++) {
        if (email.folder === state.types[i].type) {
            return state.types[i].direction === direction;
        }
    }

    return false;
};

// Kunde passt zu einer der Sprachen: Land der Hauptadresse (fr => FR, de_DE => DE),
// nur ohne Adresse zählt die Kundensprache
const clientHasLanguage = function (client, languages) {
    if (!client) {
        return false;
    }

    return languages.some(language => client.mainCountry
        ? client.mainCountry === language.slice(-2).toUpperCase()
        : client.mainLanguage === language
    );
};

const getRequestSortHelper = function (request) {
    if (!!request.placeholder && (typeof request.placeholder === 'string' || request.placeholder.id)) {
        //placeholder kommt je nach Serializer-Gruppen als IRI-String oder als Objekt
        const id = typeof request.placeholder === 'string' ? request.placeholder.split('/').pop() : request.placeholder.id;

        if (request.requestType ==='hotel')  {
            return `hotel-${id}`;
        } else if (request.requestType ==='ferry') {
            return `ferry-${id}`
        } else if (request.requestType ==='train') {
            return `train-${id}`
        } else if (request.requestType ==='airline')  {
            return `airline-${id}`
        } else {
            return `other-${id}`
        }
    } else {
        return false
    }
}

const emailStore = {
    state: {
        //For live emails
        types: [
            /*{ title: 'Neue Emails',          type: 'inbox',                  direction: 'in'  },
            { title: 'Gesendet',             type: 'sent',                   direction: 'out' },
            // { title: 'Papierkorb',        type: 'trash' },

            { title: 'Wichtig',              type: 'travelize.important',    direction: 'in'  },
            { title: 'Sonstige Emails',      type: 'travelize.other',        direction: 'in'  },
            { title: 'Erledigt',             type: 'travelize.archive',      direction: 'in'  },
            { title: 'Postausgang Erledigt', type: 'travelize.archive_sent', direction: 'out' },
            // { title: 'Papierkorb',        type: 'travelize.trash' }*/
            { title: 'Posteingang',        type: 'INBOX',          direction: 'in'  },
            { title: 'Postausgang',        type: 'Drafts',         direction: 'in'  },
            { title: 'Gesendete Elemente', type: 'Sent Items',     direction: 'in'  },
            { title: 'Papierkorb',         type: 'Deleted Items',  direction: 'in'  },
            { title: 'Öffentliche Ordner', type: 'Public Folders', direction: 'in'  },
        ],
        emailsServer:   [],
        emailsLive:     [],
        emailsSelected: {
            direction: 'in',
            in:  [],
            out: []
        },
        updateFolder:  false,
        loadingFolder: false,
        isLoading: false,
        isLoadingPreview: false,
        cancelTokens: {
            preview: null,
        },


        //index.php ->orderSelect and provider/client/request select
        emailType: 'client', //Email an Kunde oder Leistungsträger
        orders: [], //order options for multiselect
        ordersSelected: [], //selected order in multiselect
        isLoadingOrders: false,


        providers: [], //all providers of the selected orders (options) including all requests
        providerSelected: null, //if email goes to provider or agency,
        isLoadingProviders: false,
        requestsSelected: [], //selectedRequests for provider or agency
        bulkMode: false, //Massenemails an Leistungsträger: eine Email pro Leistungsträger, Editor bleibt ungerendert
        bulkContacts: {}, //bulkMode: gewählter Kontakt pro Provider (key = feID)
        bulkListMode: false, //bulkMode aus einer reiseübergreifenden Liste (Einkauf): Leistungen sind vorgegeben, eine Email pro Leistungsträger UND Reise

        //for orderConcepts (procurement)
        orderConceptsSelected: [],
        conceptProvidersSelected: [],
        priceRequestYear: null,

        action:        null, //new, reply, forward

        //Form
        users: [],
        contacts: [],
        templates: {
            provider: {
                de_DE: {
                    formal: [],
                    informal: [],
                },
                fr: {
                    formal: [],
                    informal: [],
                },
                en: {
                    formal: [],
                    informal: [],
                },
            },
            client: {
                de_DE: {
                    formal: [],
                    informal: [],
                },
                fr: {
                    formal: [],
                    informal: [],
                },
                en: {
                    formal: [],
                    informal: [],
                },
            },
        },
        settings: settings,
        isPhone: false,
        sourceFilter: [], // Filter templates by source (buspaket, welcome)
        templateSelected: null,
        isFormal: true,
        localeSelected: 'de_DE',
        variantSelected: null,
        newEmail: {
            fromEmail: null,
            toAddresses: [],
            ccAddresses: [],
            bccAddresses: [],
            subject: null,
            textHtml: '',
            folder: 'sent',
            todoDate: null,
            _files: []
        },
        isOpen: false,
        emailManuallyChanged: false,
        confirmationTime: null,
        _autoCcEmails: [], // von der Vorlage (template.ccAddresses) automatisch gesetzte BCC-Adressen
        _ccClientCache: {}, // clientId => Promise<client>, für template.ccClientLanguages
        cancelSource: {
            'orderSearch': null,
            'preview': null
        },
    },


    getters: {
        //bulkMode: selektierte Requests gruppiert nach Provider/Agentur => eine Email pro Gruppe
        bulkGroups: function (state) {
            if (!state.bulkMode) {
                return [];
            }

            const groups = state.providers
                .map(providerItem => ({
                    feID:     providerItem.feID,
                    //Kontakt wird pro Leistungsträger gewählt — im Listen-Modus gilt er für alle Reisen des LT
                    contactKey: providerItem.contactKey || providerItem.feID,
                    provider: providerItem.provider,
                    isAgency: providerItem.isAgency,
                    orderID:  providerItem.orderID,
                    requests: providerItem.requests.filter(request => state.requestsSelected.some(item => item.id === request.id))
                }))
                .filter(group => group.requests.length > 0);

            //Listen-Modus: nach Leistungsträger gebündelt, je LT chronologisch nach frühester Leistung
            if (state.bulkListMode) {
                const firstDate = group => Math.min(...group.requests.map(request => moment(request.info.startAt, 'DD.MM.YYYY').valueOf()));
                groups.sort((a, b) => (a.provider.name || '').localeCompare(b.provider.name || '') || firstDate(a) - firstDate(b));
            }

            return groups;
        },

        //bulkMode: Kontakt einer Gruppe (explizit gewählt > requestContact > erster Provider-Kontakt mit Email)
        bulkGroupContact: function (state) {
            return group => {
                const contactKey = group.contactKey || group.feID;
                if (state.bulkContacts[contactKey]) {
                    return state.bulkContacts[contactKey];
                }
                //Listen-Modus: ein Kontakt pro LT über alle Reisen hinweg => alle gewählten Leistungen des LT betrachten
                const requests = state.bulkListMode
                    ? state.providers
                        .filter(providerItem => providerItem.contactKey === contactKey)
                        .reduce((all, providerItem) => all.concat(providerItem.requests), [])
                        .filter(request => state.requestsSelected.some(item => item.id === request.id))
                    : group.requests;
                const requestWithContact = requests.find(request => request.requestContact && request.requestContact.email);
                if (requestWithContact) {
                    return requestWithContact.requestContact;
                }
                return (group.provider.contacts || []).find(contact => contact.email) || null;
            };
        },

        emailsListIn: function (state) {
            return [
                ...state.emailsLive.filter(email   => isDirection(email, state, 'in')),
                ...state.emailsServer.filter(email => isDirection(email, state, 'in'))
            ];
        },


        emailsListOut: function (state) {
            return [
                ...state.emailsLive.filter(email   => isDirection(email, state, 'out')),
                ...state.emailsServer.filter(email => isDirection(email, state, 'out'))
            ];
        },

        emailsListByType: function (state, getters) {
            let list = {
                in: {},
                out: {}
            };

            state.types.forEach(type => {
                if (type.direction === 'in') {
                    list.in[type.type]  = getters.emailsListIn.filter(email  => email.folder === type.type);
                } else {
                    list.out[type.type] = getters.emailsListOut.filter(email => email.folder === type.type);
                }
            });

            return list;
        },


        emailsSelected: function (state) {
            return state.emailsSelected[state.emailsSelected.direction];
        },


        email: function (state) {
            // In order to pass arguments to getters we need to return a function
            return ({ id, folder }) => {
                for (let i = 0, len = state.emailsLive.length; i < len; i++) {
                    if (state.emailsLive[i].uid === id && state.emailsLive[i].folder === folder) {
                        return state.emailsLive[i];
                    }
                }
                for (let i = 0, len = state.emailsServer.length; i < len; i++) {
                    if (state.emailsServer[i].id === id && state.emailsServer[i].folder === folder) {
                        return state.emailsServer[i];
                    }
                }

                return null;
            };
        },


        isLive: function (state) {
            return (email) => !email.id;
        },


        isDirection: function (state) {
            return (email, direction) => isDirection(email, state, direction);
        }
    },


    mutations: {
        updateEmailsServer: function (state, list) { state.emailsServer = list; },
        updateEmailsLive:   function (state, list) { state.emailsLive   = list; },


        updateFolder:  function (state, shouldUpdate) { state.updateFolder  = shouldUpdate; },
        loadingFolder: function (state, isLoading)    { state.loadingFolder = isLoading; },


        updateEmailsSelected: function (state, object) {
            if (object.event && object.event.shiftKey) {
                // Multi email select
                const index = state.emailsSelected[state.emailsSelected.direction].findIndex(email =>
                    (object.email.id ? email.id === object.email.id : email.uid === object.email.uid));

                if (index !== -1) {
                    // Deselecting one
                    if (state.emailsSelected[state.emailsSelected.direction].length > 1) {
                        state.emailsSelected[state.emailsSelected.direction].splice(index, 1);
                    }

                } else {
                    // Adding multiselect - at the begging of the array
                    state.emailsSelected[state.emailsSelected.direction].unshift(object.email);
                }

            } else {
                // Simple click
                state.emailsSelected[state.emailsSelected.direction] = [object.email];
            }
        },


        // When we change the folder we need to empty the list and select the email given (the first email if any)
        updateChangeFolder: function (state, object) {
            state.emailsSelected[state.emailsSelected.direction] = object;
        },


        updateDirection: function (state, direction) {
            state.emailsSelected.direction = direction;
        },


        movedFromLive: function (state, emails) {
            // Updating the emailsSelected list
            const indexSelected = state.emailsSelected[state.emailsSelected.direction].findIndex(email => email.uid    === emails.old.uid &&
                email.folder === emails.old.folder);
            if (indexSelected !== -1) {
                state.emailsSelected[state.emailsSelected.direction].splice(indexSelected, 1, emails.new);
            }

            // Deleting the old
            const indexLive = state.emailsLive.findIndex(email => email.uid    === emails.old.uid &&
                email.folder === emails.old.folder);

            if (indexLive !== -1) {
                state.emailsLive.splice(indexLive, 1);
            }

            // Adding the new
            state.emailsServer.unshift(emails.new);
        },


        updateEmailOnServer: function (state, { id, folder, links, tags }) {
            const index = state.emailsServer.findIndex(email => email.id === id);
            state.emailsServer[index].folder = folder;
            state.emailsServer[index].links  = links;
            state.emailsServer[index].tags   = tags;
        },


        /*
            ==================== INTERNALS - For in VUEX store use ONLY ====================
        */
        internalInitialEmailsSelected: function (state, object) {
            state.emailsSelected[object.direction] = [object.email];
        },


        internalDeleteEmailsSelected: function (state) {
            let index = -1;

            state.emailsSelected[state.emailsSelected.direction].forEach(email => {
                if (email.id) {
                    index = state.emailsServer.findIndex(emailServer => email.id === emailServer.id);
                    if (index !== -1) {
                        state.emailsServer.splice(index, 1);
                    }

                } else {
                    index = state.emailsLive.findIndex(emailLive => email.uid === emailLive.uid && email.folder === emailLive.folder);
                    if (index !== -1) {
                        state.emailsLive.splice(index, 1);
                    }
                }
            });
            state.emailsSelected[state.emailsSelected.direction] = [];
        },
        /* ================================ End of INTERNALS ================================ */


        updateOrders:  function (state, newOrders)  { state.orders  = newOrders; },

        updateClients: function (state, newClients) { state.clients = newClients; },
        updateUsers:   function (state, newUsers)   { state.users   = newUsers; },


        updateAction:  function (state, newAction) {
            if (state.emailsSelected[state.emailsSelected.direction].length > 0) {
                state.action = newAction;

            } else {
                state.action = null;
            }
        },
        updateTemplates: function (state, newTemplates) { state.templates = newTemplates; },
        updateLoading: function (state, newState) { state.isLoading = newState; },

        updateProviderSelected: function (state, provider) { state.providerSelected = provider; },

        updateOrderLoading: function(state, value) {state.isLoadingOrders = value; },

        cancelSearch : function (state, key) {
            if (state.cancelSource[key]) {
                state.cancelSource[key].cancel('Axios canceled');
            }
        },

        updateContacts: function(state) {
            console.log(state)
            state.contacts = [];
            if(state.emailType === 'provider' && state.providerSelected && state.providerSelected.provider && state.providerSelected.provider.contacts && state.providerSelected.provider.contacts.length > 0) {
                state.contacts = JSON.parse(JSON.stringify(state.providerSelected.provider.contacts));
            } else if(state.ordersSelected.length > 0 && state.ordersSelected[0].client.contacts && state.ordersSelected[0].client.contacts.length > 0 && state.ordersSelected[0].client.contacts[0].id) {
                state.contacts =  JSON.parse(JSON.stringify(state.ordersSelected[0].client.contacts.filter(contact => contact.email || state.isPhone)));
            } else if(state.conceptProvidersSelected.length > 0 && state.conceptProvidersSelected[0].contacts) {
                state.contacts = JSON.parse(JSON.stringify(state.conceptProvidersSelected[0].contacts));
            }
            let usersArray = state.users.filter(item => item.userEmails.length > 0).map(item => {

                let email = null;
                if(state.ordersSelected && state.ordersSelected[0]) {
                    email = item.userEmails.find(userEmail => userEmail.organisation.id === state.ordersSelected[0].organisationFilter.id);
                }
                if(!email) {
                    email = item.userEmails[0];
                }
                return {
                    ...item,
                    email: email.email,
                }
            });
            if(typeof state.contacts === 'object') {
                state.contacts = Object.values(state.contacts);
            }
            state.contacts.push(...usersArray);


        },

        setBulkContact: function (state, { feID, contact }) {
            Vue.set(state.bulkContacts, feID, contact);
        },

        addToProviders: function (state, request) {
            let provider    = null;
            let isAgency = false;
            let requestType = request.requestType ? request.requestType : 'agency';

            if(request.agency) {
                provider = request.agency;
                isAgency = true;
            } else if (request.requestType === 'hotel') {
                provider    = request.hotel;
            } else if (request.requestType === 'ferry') {
                provider    = request.ferry;
            } else if (request.requestType === 'airline') {
                provider    = request.airline;
            } else if(request.provider === 'train') {
                provider    = request.train;
            } else {
                provider    = request.provider;
            }

            /*console.log(state.providers)
            console.log(provider.id)*/
            if(!provider) {
                return;
            }

            //bulkListMode: Gruppe = Leistungsträger + Reise (die Vorlagen gehen von einer Reise pro Email aus)
            const orderID = state.bulkListMode ? request.orderID : null;

            const index = state.providers.findIndex(providerItem => {
                return isAgency === providerItem.isAgency && providerItem.provider.id === provider.id
                    && (!state.bulkListMode || providerItem.orderID === orderID)
            });

            if (index !== -1) {
                // We found it. We just need to add the request to its list
                let requestIndex = state.providers[index].requests.findIndex(item => item.id === request.id);
                if(requestIndex === -1) {
                    state.providers[index].requests.push(request);
                }
            } else {
                // No provider found. We add the provider with its request
                // (agency im Key: Agentur- und Provider-IDs sind getrennte Sequenzen —
                // "hotel-<agencyId>" könnte sonst mit einem echten Hotel kollidieren)
                state.providers.push({
                    feID:     (isAgency ? 'agency' : requestType) + '-' + provider.id + (orderID ? '-' + orderID : ''),
                    contactKey: (isAgency ? 'agency' : requestType) + '-' + provider.id,
                    provider: provider,
                    isAgency: isAgency,
                    orderID:  orderID,
                    requests: [request]
                });
            }
        },
    },


    actions: {
        getUsers: function (context) {
            return new Promise(resolve => {
                if(context.state.users.length === 0) {
                    getUsers().then(response => {
                        context.commit('updateUsers', response.data);
                        resolve(response.data);
                    });
                } else {
                    resolve(context.state.users);
                }
            });
        },

        getTemplates: function (context) {
            return new Promise(resolve => {
                let formal = context.state.isFormal ? 'formal' : 'informal';
                // Build cache key including source filter
                let sourceKey = context.state.sourceFilter.length > 0 ? context.state.sourceFilter.join(',') : 'all';
                let cacheKey = `${context.state.emailType}_${context.state.localeSelected}_${formal}_${sourceKey}`;

                // Check if we have cached templates for this combination
                if (!context.state._templateCache) {
                    context.state._templateCache = {};
                }

                if (context.state._templateCache[cacheKey] && context.state._templateCache[cacheKey].length > 0) {
                    resolve(context.state._templateCache[cacheKey]);
                } else {
                    let params = {
                        isFormal: context.state.isFormal,
                        category: context.state.emailType,
                        locale: context.state.localeSelected,
                        _groups: ['email_template:email_variant', 'email_variant']
                    };

                    // Add source filter if selected
                    if (context.state.sourceFilter.length > 0) {
                        params['mergeStatus'] = context.state.sourceFilter;
                    }

                    getAxios('email_templates', params).then(response => {
                        context.state._templateCache[cacheKey] = response.data;
                        // Also update the legacy templates structure for backward compatibility
                        context.state.templates[context.state.emailType][context.state.localeSelected][formal] = response.data;
                        resolve(response.data);
                    })
                }
            })
        },

        resetTemplates: function(context, payload) {
            if(context.state.isPhone) {
                return;
            }

            let { templateToSelect, formalitySwitched } = payload && typeof payload === 'object'
                ? payload : { templateToSelect: payload };

            context.dispatch('getTemplates').then(response => {
                // keine Vorlagen in dieser Du/Sie-Form (z.B. Welcome FR nur "Sie") -> andere Form probieren
                if(response.length === 0 && !formalitySwitched && settings.emails.isFormal[context.state.emailType]) {
                    context.state.isFormal = !context.state.isFormal;
                    context.dispatch('resetTemplates', { templateToSelect, formalitySwitched: true });
                    return;
                }

                let standardTemplates = response;

                if(context.state.templateSelected && context.state.variantSelected) {
                    context.state.templateSelected = standardTemplates.find(
                        template => template.name === context.state.templateSelected.name
                    )
                    if(context.state.templateSelected ) {
                        context.state.variantSelected = context.state.templateSelected.variants.find(variant => variant.name === context.state.variantSelected.name)
                        if(context.state.variantSelected) {
                            context.dispatch('fillEmailBody');
                            return;
                        }
                    }
                }

                if(!templateToSelect) {
                    templateToSelect = 'client';
                    if(context.state.emailType === 'provider' && context.state.providerSelected && context.state.providerSelected.requests.length > 0) {
                        templateToSelect = context.state.providerSelected.requests[0].requestType;
                    } else if(context.state.bulkMode) {
                        templateToSelect = context.state.requestsSelected.length > 0 ? context.state.requestsSelected[0].requestType : 'hotel';
                    }
                }
                if(templateToSelect) {
                    let found = standardTemplates.filter(template => template.defaultArray.includes(templateToSelect));
                    standardTemplates = found.length > 0 ? found : standardTemplates;
                }

                //select template and variant
                if(standardTemplates.length > 0) {
                    context.state.templateSelected = standardTemplates[0];
                    let variant = context.state.templateSelected.variants.find(item => item.variantStandard);
                    if(context.state.templateSelected.variants.length > 0) {
                        context.state.variantSelected = variant ? variant : context.state.templateSelected.variants[0];
                        context.dispatch('fillEmailBody');
                    }
                }
            });
        },

        // Auto-Adressen der gewählten Vorlage (template.ccAddresses, landen in BCC) setzen, die der vorherigen Vorlage wieder entfernen.
        // template.ccClientLanguages schränkt auf Kunden ein (Kundensprache oder Adress-Land, z.B. fr => FR)
        applyTemplateCc: function(context) {
            const template = context.state.templateSelected;
            const templateCc = !context.state.bulkMode && template && template.ccAddresses ? template.ccAddresses : [];
            const languages = template && template.ccClientLanguages ? template.ccClientLanguages.filter(Boolean) : [];

            const check = templateCc.length > 0 && languages.length > 0
                ? context.dispatch('getCcClient').then(client => clientHasLanguage(client, languages))
                : Promise.resolve(true);

            check.then(matches => {
                const newEmail = context.state.newEmail;
                // inzwischen andere Vorlage gewählt -> deren Aufruf übernimmt
                if (context.state.templateSelected !== template || !newEmail || !newEmail.bccAddresses) {
                    return;
                }

                const previous = context.state._autoCcEmails;
                let bccAddresses = newEmail.bccAddresses.filter(address => !previous.includes(address.email));
                const added = [];
                (matches ? templateCc : []).forEach(address => {
                    if (address.email && !bccAddresses.some(item => item.email === address.email)) {
                        bccAddresses.push({email: address.email, firstName: address.name || '', lastName: ''});
                        added.push(address.email);
                    }
                });

                context.state._autoCcEmails = added;
                if (previous.length > 0 || added.length > 0) {
                    newEmail.bccAddresses = bccAddresses;
                }
            });
        },

        // Kunde des (ersten) Auftrags inkl. Sprache + Land der Hauptadresse, gecacht pro Client-ID
        getCcClient: function(context) {
            const order = context.state.ordersSelected[0];
            const client = order ? order.client : null;
            const clientId = client ? (typeof client === 'string' ? getIDFromString(client) : client.id) : null;
            if (!clientId) {
                return Promise.resolve(null);
            }

            if (!context.state._ccClientCache[clientId]) {
                context.state._ccClientCache[clientId] = axios.get('/api/clients/' + clientId, {params: {'_groups[]': 'client_main_country'}})
                    .then(response => response.data, () => null);
            }
            return context.state._ccClientCache[clientId];
        },

        fillEmailBody: function(context) {
            context.dispatch('applyTemplateCc');

            let duration = 100;
            if(context.state.confirmationTime) {
                let date = moment ();
                duration = moment.duration(date.diff(context.state.confirmationTime)).asSeconds();
            }
            if(context.state.emailManuallyChanged && (duration < 5 || !confirm('Soll das Template neu geladen werden?'))) {
                context.state.confirmationTime = moment();
                return;
            }
            context.state.emailManuallyChanged = false;
            if(context.state.isPhone) {
                return;
            }
            if (context.state.variantSelected) {
                let textHtml = '';

                let textPhone = '';
                if(currentUser('phoneDirect')){
                    textPhone = '(Dw. ' + currentUser('phoneDirect') + ')';
                }

                let action = context.state.action === 'reply' ||
                    context.state.action === 'replyAll' ||
                    context.state.action === 'forward';


                let organisationId = context.state.newEmail.fromEmail ? parseInt(context.state.newEmail.fromEmail.organisation.replace('/api/organisations/', '')) : 1;

                if (action) {
                    //Only change body
                    textHtml = emailBody(organisationId, context.state.variantSelected.content, textPhone, context.getters.emailsSelected[0], context.state.localeSelected);
                } else {
                    context.state.newEmail.subject = context.state.variantSelected.subject ? context.state.variantSelected.subject : context.state.newEmail.subject;
                    textHtml = emailBody(organisationId, context.state.variantSelected ? context.state.variantSelected.content : '', textPhone);
                }
                context.state.newEmail.textHtml = textHtml;
            }

            context.dispatch('renderTemplate');
        },

        renderTemplate: function(context) {
            //Massenemail: der Editor behält die Twig-Platzhalter, gerendert wird nur die Vorschau pro Empfänger
            if (context.state.bulkMode) {
                return;
            }

            let apiQuery = '?',
                ids      = [];

            // Orders come from the "Vorgänge" selection (on reply/forward it is preselected from the email's links)
            if (context.state.ordersSelected.length > 0) {
                ids = uniq(context.state.ordersSelected.map(order => order.id));
                apiQuery += 'orders[]=' + ids.join('&orders[]=');
            }

            if(context.state.orderConceptsSelected.length > 0) {
                apiQuery += 'orderConcepts[]=' + context.state.orderConceptsSelected.map(order => order.id).join('&orderConcepts[]=');
            }

            if(context.state.newEmail.toAddresses.length > 0) {
                apiQuery += '&';
                apiQuery += context.state.newEmail.toAddresses.map(contact => contact.id ? 'toContacts[]=' + contact.id : 'toContactsEmail[]=' + contact.email ).join('&');
            }

            if(context.state.newEmail.bccAddresses.length > 0) {
                apiQuery += '&';
                apiQuery += context.state.newEmail.bccAddresses.map(contact => contact.id ? 'bccContacts[]=' + contact.id : '').join('&');
            }

            if(context.state.newEmail.ccAddresses.length > 0) {
                apiQuery += '&';
                apiQuery += context.state.newEmail.ccAddresses.map(contact => contact.id ? 'ccContacts[]=' + contact.id : '').join('&');
            }

            if(context.state.requestsSelected.length > 0) {
                apiQuery += '&';
                apiQuery += context.state.requestsSelected.map(request => 'requests[]=' + request.id).join('&');
            }

            if(context.state.conceptProvidersSelected.length > 0) {
                apiQuery += '&';
                apiQuery += context.state.conceptProvidersSelected.map(request => 'conceptProviders[]=' + request.id).join('&');
            }



            context.state.isLoadingPreview = true;

            if(context.state.newEmail.textHtml) {
                context.dispatch('callCancelRequest', 'preview');
                let cancelToken = context.state.cancelSource['preview'].token;
                axios.post(
                    '/api/email_preview' + apiQuery,
                    {
                        content: context.state.newEmail.textHtml,
                        subject: context.state.newEmail.subject
                    },
                    {
                        headers: {'X-LOCALE': context.state.localeSelected},
                        cancelToken: cancelToken
                    }
                ).then(response => {
                    let content = response.data.content;
                    // Fix relative paths for signature images
                    if (content) {
                        content = content.replace(/\.\.\/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
                        content = content.replace(/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
                    }
                    context.state.newEmail.textHtml = content;
                    context.state.newEmail.subject  = response.data.subject;
                    context.state.isLoadingPreview = false;

                }, error => {
                    context.state.isLoadingPreview = false;
                    notifyError(error.response.data + '! Server Error!');
                });
            }

        },

        resetToContacts: function(context, {contactToSelect = null, selectContact = true, contactsToSelect = []}) {
            //toContacts
            return new Promise(resolve => {
                context.dispatch('getUsers').then(response => {
                    context.commit('updateContacts');
                    if(selectContact) {
                        if(contactToSelect && contactToSelect.email) {
                            context.state.newEmail.toAddresses = [contactToSelect];
                        } else if(contactsToSelect && contactsToSelect.length > 0) {
                            context.state.newEmail.toAddresses = contactsToSelect;
                        } else if(context.state.emailType === 'provider' && context.state.requestsSelected.length > 0) {
                            if(context.state.requestsSelected[0].requestContact) {
                                context.state.newEmail.toAddresses = [context.state.requestsSelected[0].requestContact];
                            }
                        } else {
                            context.state.newEmail.toAddresses = [context.state.contacts[0]];
                        }
                    }
                    resolve(context.state.newEmail.toAddresses);
                });
            })

        },

        resetPhoneForm: function(context) {
            context.state.newEmail.textHtml = '';
            context.state.newEmail.subject = '';
            context.state.newEmail.date = moment().format('DD.MM.YYYY HH:mm:ss');

            if(context.state.action === 'edit') {
                context.state.newEmail = context.getters.emailsSelected[0];
                context.dispatch('resetToContacts', {contactToSelect: null, selectContact: false}).then(response => {
                    if(context.getters.emailsSelected[0].contact.emailInfos) {
                        context.state.newEmail.contact = context.state.contacts.find(item => item.fullName === context.getters.emailsSelected[0].contact.emailInfos[2])
                    }
                })
            } else {
                context.dispatch('resetToContacts', {contactToSelect: null, selectContact: false}).then(response => {

                })
            }
        },

        handleReply: function(context) {
            let selectedEmail = JSON.parse(JSON.stringify(context.getters.emailsSelected[0]));
            context.state.newEmail.subject = (this.action === 'forward' ? 'FW: ' : 'RE: ') + escapeTwig(selectedEmail.subject);
            if (context.state.action === 'replyAll' ) {
                let toAddresses = [
                    {
                        email: selectedEmail.fromAddress,
                        firstName: selectedEmail.fromName,
                        lastName: null,
                    }
                ];
                selectedEmail.toAddresses.map(item => {
                    toAddresses.push({
                        email:     item.email,
                        firstName: item.name,
                        lastName:  null,
                        ...selectedEmail.contact && selectedEmail.contact.emailInfos && selectedEmail.contact.emailInfos[3] && {
                            id: selectedEmail.contact.emailInfos[3] }
                    })
                });
                context.state.newEmail.toAddresses = toAddresses.filter(address => address.email !== context.state.newEmail.fromEmail.email);
            } else if (context.state.action === 'reply'){
                context.state.newEmail.toAddresses = [{
                    email:     selectedEmail.fromAddress,
                    firstName: selectedEmail.fromName,
                    lastName:  null,
                    ...selectedEmail.contact && selectedEmail.contact.emailInfos && selectedEmail.contact.emailInfos[3] && {
                        id: selectedEmail.contact.emailInfos[3]
                    }
                }];
            }
            context.state.newEmail.links       = selectedEmail.links;
            if(context.state.action === 'forward') {
                if (selectedEmail.attachments) {
                    context.state.newEmail._files = selectedEmail.attachments.filter(item => item.disposition === 'attachment').map(item => ({
                        ...item,
                        name: item.fileName ? item.fileName : item.filename,
                    }));
                }
            }


        },

        resetEmailForm: function(context, {templateToSelect, contactToSelect, documentToAttach}) {
            //From
            if(context.state.ordersSelected && context.state.ordersSelected.length > 0) {
                let userEmail = currentUser('userEmails').find(email => email.organisation === '/api/organisations/' + context.state.ordersSelected[0].organisationFilter.id);
                context.state.newEmail.fromEmail = userEmail;
                if(currentUser('settings') && currentUser('settings')['fillBCC']) {
                    context.state.newEmail.bccAddresses.push(userEmail)
                }
            }


            let action = context.state.action === 'reply' ||
                context.state.action === 'replyAll' ||
                context.state.action === 'forward';

            //attachments
            context.state.newEmail._files = [];
            if(documentToAttach) {
                context.state.newEmail._files = [documentToAttach];
            }
            if(action) {
                context.dispatch('handleReply');
                if(context.state.newEmail.toAddresses.length === 1) {
                    context.dispatch('resetToContacts', {contactToSelect: context.state.newEmail.toAddresses[0]});
                } else {
                    context.dispatch('resetToContacts', {contactsToSelect: context.state.newEmail.toAddresses});
                }
            } else {
                // Don't carry the links of a previously replied/forwarded email into a new one
                context.state.newEmail.links = [];
                console.log('resetToContacts')
                context.dispatch('resetToContacts', {contactToSelect: contactToSelect});
            }


            //get and select templates and render
            context.dispatch('resetTemplates',templateToSelect);
        },

        callCancelRequest : function (context, key) {
            context.commit('cancelSearch', key);
            context.state.cancelSource[key] = axios.CancelToken.source();
        },

        orderSearch: function (context, query) {
            if (query) {
                let queryString = '?_search=' + query;

                // For getting basic info about the order (which by default is all closed)
                queryString += '&' + orderQueryString;

                context.state.isLoadingOrders = true;

                context.dispatch('callCancelRequest', 'orderSearch');
                let cancelToken = context.state.cancelSource['orderSearch'].token;

                getOrders(queryString, this.params, cancelToken).then(response => {
                    context.state.orders = response.data;
                }, error => {
                    if(!axios.isCancel(error)) {
                        notifyError('Die Reisen konnten nicht geladen werden! Server error!');
                    }
                })
                    .then(() => { context.state.isLoadingOrders = false; });
            }
        },

        getRequests: function (context) {
            let calls = [];

            context.state.isLoadingProviders = true;

            context.state.ordersSelected.forEach(order => {
                calls.push(getRequestsByOrder(order.id, '&_groups[]=order_list_read&_groups[]=provider_read&_groups[]=agency_read&_groups[]=order_request_contingent_read&_groups[]=order_contingent_item_read&_groups[]=order_request_deadline_read&_groups[]=order_request_status_read&_groups[]=other_service_type_read&_groups[]=contact_read&_groups[]=order_request_placeholder_read'));
            });

            Promise.all(calls).then(arrays => {
                arrays.forEach((responses, index) => {
                    [].concat(...responses.map(response => response.data)).forEach(request => {
                        // Adding the order so we can group them by request later on
                        request.orderID = context.state.ordersSelected[index].id;

                        const requestSortHelper = getRequestSortHelper(request);
                        if (requestSortHelper) {
                            request._sort = (get(context.state.ordersSelected, [index, 'sortHelper'], []) || [])
                                .findIndex(sortHelper => sortHelper === requestSortHelper);
                        }

                        context.commit('addToProviders', request);

                    });
                });

//                this.setPreselectedClient();

            }, error => { notifyError('Die Provider konnten nicht geladen werden! Server Error!'); })
                .then(() => { context.state.isLoadingProviders = false; });
        },

        //bulkListMode: nur die übergebenen Zusatzleistungs-Anfragen laden (statt aller Leistungen ganzer Reisen)
        //und alle vorauswählen; die betroffenen Reisen werden zu ordersSelected
        loadBulkRequests: function (context, requestIds) {
            context.state.isLoadingProviders = true;
            context.state.providers = [];
            context.state.requestsSelected = [];
            context.state.ordersSelected = [];

            return getAxios('other_requests', {
                id: requestIds,
                _itemsPerPage: requestIds.length,
                _groups: ['order_list_read', 'provider_read', 'agency_read', 'order_request_contingent_read', 'order_contingent_item_read', 'order_request_deadline_read', 'order_request_status_read', 'other_service_type_read', 'contact_read', 'order_request_placeholder_read'],
            }).then(response => {
                const requests = response.data;

                return context.dispatch('getOrders', uniq(requests.map(request => request.orderId))).then(orders => {
                    context.commit('updateOrders', orders);
                    context.commit('updateOrderLoading', false);
                    context.state.ordersSelected = orders;

                    requests.forEach(request => {
                        request.orderID = request.orderId;

                        const order = orders.find(item => item.id === request.orderID);
                        const requestSortHelper = getRequestSortHelper(request);
                        if (order && requestSortHelper) {
                            request._sort = (order.sortHelper || []).findIndex(sortHelper => sortHelper === requestSortHelper);
                        }

                        context.commit('addToProviders', request);
                    });

                    context.state.requestsSelected = requests;
                    context.state.emailType = 'provider';
                    context.state.isFormal = settings.emails.selectedIsFormal.provider;
                });
            }, error => { notifyError('Die Leistungen konnten nicht geladen werden! Server Error!'); })
                .then(() => { context.state.isLoadingProviders = false; });
        },

        preselectOrderConcepts: function (context, {preselectedOrderConcept, preselectedConceptProvider = null}) {
            let orders = [];
            if(preselectedOrderConcept){
                context.state.orderConceptsSelected = Array.isArray(preselectedOrderConcept) ? preselectedOrderConcept : [preselectedOrderConcept];
            }
            return context.dispatch('processPreselectedConceptProvider', {preselectedConceptProvider})
        },

        preselectOrders: function (context, {preselectedOrder, preselectedRequest = null}) {
            let action = context.state.action === 'reply' ||
                context.state.action === 'replyAll' ||
                context.state.action === 'forward' ||
                context.state.action === 'edit';
            let orders = [];
            let emailSelected = context.state.emailsSelected[context.state.emailsSelected.direction][0];
            if(emailSelected && action) {
                orders = emailSelected.links.map(link => link.order ? link.order.id : null);
                // Removing the nulls
                orders = orders.filter(id => id !== null);
                if(preselectedOrder) {
                    orders = orders.map(order => order === preselectedOrder.id ? preselectedOrder : order).sort((a,b) => {
                        if(a.id ) {
                            return -1;
                        }
                        if(b.id) {
                            return 1
                        }
                        return 0;
                    })
                }
                // Only unique (as we may have multiple links from the same order)
                orders = uniq(orders);
            } else if(preselectedOrder){
                orders = Array.isArray(preselectedOrder) ? preselectedOrder : [preselectedOrder];
            }
            return context.dispatch('processPreselectedOrders', {orders, preselectedRequest, preselectedOrder})
        },

        getOrders: function (context, orders) {
            return new Promise((resolve, reject) => {
                let orderIds = [];
                let ordersWithDetails = [];

                orders.map(order => {
                    if(!order.id) {
                        orderIds.push(order);
                    }  else {
                        ordersWithDetails.push(order);
                    }
                })
                if (orderIds.length > 0) {
                    context.commit('updateOrderLoading', true);
                    getOrders('?' + orderQueryString, {
                        'id': orderIds
                    }).then(response => {
                        ordersWithDetails.push(...response.data);
                        console.log('resoolveORder')
                        resolve(ordersWithDetails);
                    })
                } else {
                    console.log('resoolveORder')
                    resolve(ordersWithDetails);
                }
            });
        },


        processPreselectedOrders: function(context, {orders, preselectedRequest, preselectedOrder}) {
            return new Promise((resolve, reject) => {
                context.dispatch('getOrders', orders).then(response => {
                    context.commit('updateOrders', response);
                    context.state.ordersSelected = response;
                    context.commit('updateOrderLoading', false);
                    context.dispatch('processPreselectedRequest', {preselectedRequest, preselectedOrder}).then(response => {
                        resolve('orders and requests loaded');
                    });
                });
            })
        },

        getPreselectedConceptProvider: function(context, {preselectedConceptProvider}) {
            return new Promise((resolve, reject) => {
                let action = context.state.action === 'reply' ||
                    context.state.action === 'replyAll' ||
                    context.state.action === 'forward';
                let emailSelected = context.state.emailsSelected[context.state.emailsSelected.direction][0];
                if (preselectedConceptProvider) {
                    //If preselectedConcept already exists, only get contacts
                    let providerFilter = preselectedConceptProvider.agency ? 'agency.id' : 'provider.id';
                    getAxios('contacts', {
                        ...preselectedConceptProvider.agency && {'agency.id': preselectedConceptProvider.agency.id},
                        ...!preselectedConceptProvider.agency && {'provider.id': preselectedConceptProvider.provider.id},
                    }).then(response => {
                        preselectedConceptProvider = {
                            ...preselectedConceptProvider,
                            contacts: response.data
                        }
                        resolve([preselectedConceptProvider]);
                    })
                } else if(action && emailSelected && emailSelected.contact && emailSelected.contact.emailInfos) {
                    //if email link, find conceptProviders with contacts directly
                    let splitProviderApi = emailSelected.contact.emailInfos[0].split('/');
                    if(splitProviderApi[1] === 'clients') {
                        resolve(null);
                    } else if(context.state.orderConceptsSelected.length > 0) {
                        let providerFilter = splitProviderApi[1] === 'agencies' ? 'agency.id' : 'provider.id';
                        getAxios('concept_providers', {
                            '_placeholder.day.orderConcepts.id': context.state.orderConceptsSelected[0].id,
                            [providerFilter]: splitProviderApi[2],
                            '_groups': ['contact_read', 'provider_read', 'concept_day_read']
                        }).then(response => {
                            resolve(
                                response.data.map(conceptProvider => ({
                                    ...conceptProvider,
                                    ...conceptProvider.agency && {contacts: conceptProvider.agency.contacts},
                                    ...conceptProvider.provider && {contacts: conceptProvider.provider.contacts},
                                })),
                            )
                        })
                    }
                } else {
                    resolve(null);
                }
            });
        },

        getPreselectedRequest: function(context, {preselectedRequest, preselectedOrder}) {
            return new Promise((resolve, reject) => {
                let action = context.state.action === 'reply' ||
                    context.state.action === 'replyAll' ||
                    context.state.action === 'forward';
                let emailSelected = context.state.emailsSelected[context.state.emailsSelected.direction][0];
                if (preselectedRequest) {
                    if(preselectedRequest.provider && preselectedRequest.provider.contacts) {
                        resolve([preselectedRequest]);
                    } else {
                        getAxios('requests/' + preselectedRequest.id, {
                            '_groups': ['trip_dashboard_read', 'contact_read', 'provider_read', 'order_request_read']
                        }).then(response => {
                            preselectedRequest = {preselectedRequest, ...response.data};
                            resolve([preselectedRequest]);                        })
                    }
                } else if(action && emailSelected && emailSelected.contact && emailSelected.contact.emailInfos) {
                    let splitProviderApi = emailSelected.contact.emailInfos[0].split('/');
                    if(splitProviderApi[1] === 'clients') {
                        resolve(null);
                    } else {
                        let providerFilter = splitProviderApi[1] === 'agencies' ? 'agency' : 'provider.id';
                        getAxios('requests', {
                            'request.placeholder.day.order.id': preselectedOrder.id,
                            [providerFilter]: splitProviderApi[2],
                            '_groups': ['trip_dashboard_read', 'contact_read', 'provider_read', 'order_request_read']
                        }).then(response => {
                            resolve(response.data);
                        })
                    }
                } else {
                    resolve(null);
                }
            });
        },

        processPreselectedConceptProvider: function(context, {preselectedConceptProvider}) {
            return new Promise(resolve => {
                context.dispatch('getPreselectedConceptProvider', {preselectedConceptProvider}).then(response => {
                    if (response && response.length > 0) {
                        context.state.conceptProvidersSelected = response;

                        let action = context.state.action === 'reply' ||
                            context.state.action === 'replyAll' ||
                            context.state.action === 'forward' ||
                            context.state.action === 'edit';
                        context.dispatch('resetToContacts', {contactToSelect: null, selectContact: !action});
                        resolve('provider');
                    }
                })
            });
        },

        processPreselectedRequest: function(context, {preselectedRequest, preselectedOrder}) {
            return new Promise(resolve => {
                context.dispatch('getPreselectedRequest', {preselectedRequest, preselectedOrder}).then(response => {
                    if (response && response.length > 0) {
                        context.commit('updateProviderSelected', {
                            provider: response[0].agency ? response[0].agency :
                                response[0].hotel ? response[0].hotel :
                                    response[0].ferry ? response[0].ferry :
                                        response[0].train ? response[0].train :
                                            response[0].otherService.provider,
                            requests: response
                        });
                        let action = context.state.action === 'reply' ||
                            context.state.action === 'replyAll' ||
                            context.state.action === 'forward' ||
                            context.state.action === 'edit';
                        context.dispatch('resetToContacts', {contactToSelect: null, selectContact: !action});
                        context.state.requestsSelected = response;
                        context.state.emailType = 'provider'
                        context.state.isFormal = settings.emails.selectedIsFormal.provider;
                        console.log('resolveProvider')
                        resolve('provider');
                    } else if (context.state.bulkMode) {
                        //Massenemail-Modus bleibt erhalten, Auswahl trifft BulkProviderSelect
                        context.state.emailType = 'provider'
                        context.state.isFormal = settings.emails.selectedIsFormal.provider;
                        context.state.requestsSelected = [];
                        resolve('provider');
                    } else {
                        context.state.emailType = 'client'
                        context.state.isFormal = settings.emails.selectedIsFormal.client;
                        context.state.requestsSelected = [];
                        resolve('client');
                    }
                })
            });
        },

        internalInitialEmailsSelected: function (context) {
            // Initial IN email selected once we have the list of emails
            if (context.state.emailsSelected.in.length === 0 && context.getters.emailsListIn.length > 0) {
                context.commit('internalInitialEmailsSelected', { direction: 'in', email: context.getters.emailsListIn[0] });
            }
            // Initial OUT email selected once we have the list of emails
            if (context.state.emailsSelected.out.length === 0 && context.getters.emailsListOut.length > 0) {
                context.commit('internalInitialEmailsSelected', { direction: 'out', email: context.getters.emailsListOut[0] });
            }
        },


        updateEmailsServer: function (context, list) {
            // Update the server list
            context.commit('updateEmailsServer', list);
            // Initial Email
            context.dispatch('internalInitialEmailsSelected');
        },


        updateEmailsLive: function (context, list) {
            // Update the live list
            context.commit('updateEmailsLive', list);
            // Initial Email
            context.dispatch('internalInitialEmailsSelected');
        },


        deleteEmailsSelected: function (context) {
            // Delete from List and Empty emailsSelected (for the current direction)
            context.commit('internalDeleteEmailsSelected');
            // Initial Email
            context.dispatch('internalInitialEmailsSelected');
        },
    }
}


export default new Vuex.Store(emailStore);
export {emailStore};
